module.exports = __webpack_public_path__ + "img/Aria_halo.8e1c30ec.png";